import { Theme, alpha } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = (isSingleItem, highLightColor) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...(!isSingleItem && {
          margin: '0 45px',
          [theme.breakpoints.up('md')]: {
            margin: '0 60px',
          },
          [theme.breakpoints.up('lg')]: {
            width: 800,
            margin: '0 auto',
          },
        }),
      },
      title: {
        marginBottom: SMALL_MARGIN,
        color: colorsPalette.white,
        fontWeight: 'bold',
        fontSize: 24,
        lineHeight: '28px',
        textAlign: 'center',
        width: '100%',
        ...(isSingleItem && {
          [theme.breakpoints.up('md')]: {
            fontSize: 36,
            lineHeight: '46px',
            marginBottom: MIDDLE_MARGIN,
          },
        }),
        ...(!isSingleItem && {
          [theme.breakpoints.up('md')]: {
            fontSize: 40,
            lineHeight: '52px',
          },
        }),
        '& span': {
          color: highLightColor || colorsPalette.primary,
        },
      },
      subtitle: {
        color: colorsPalette.white,
        fontSize: 18,
        lineHeight: '24px',
        textAlign: 'center',
        width: '100%',
        [theme.breakpoints.up('md')]: {
          fontSize: 20,
          lineHeight: '30px',
        },
      },
      divider: {
        maxWidth: 300,
        width: '100%',
        height: 1,
        background: alpha(colorsPalette.white, 0.33),
        marginBottom: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          display: isSingleItem ? 'none' : 'block',
        },
      },
      link: {
        marginTop: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginTop: MIDDLE_MARGIN,
        },
      },
      btn: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          width: 'unset',
        },
      },
    }),
  );

export default useStyles;
